// extracted by mini-css-extract-plugin
export default {"logo":"FooterText_logo__why9p","forceShow":"FooterText_forceShow__qUXK8"};